import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { LoadReport } from 'actions/jasperServicesActions';
import * as miscServices from 'services/miscServices';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import * as settings from 'settings/settings';
import {Row, Col} from 'react-flexbox-grid/lib';
import styles from './styles/JasperReportStyles';

class JasperReport extends React.Component {

    componentDidMount(){
        this.props.LoadReport(miscServices.getIdFromHref(this.props.currentUser.account.href));
    }

    render() {
        const {currentUser, optionsCompleted, options} = this.props;
        var isLoading = true;

        if(optionsCompleted)
        {
            isLoading = false;
        }

        var url = null;
        if(options)
        {
            console.info("report token " + options.tokenName + " " + options.token);
            url = settings.jasperBaseCrashBoxxReportUrl + "&accountId=" + miscServices.getIdFromHref(currentUser.account.href) + "&" + options.tokenName + "=" + encodeURIComponent(options.token);;
            console.info(url);
        }

        return (
            <Row style={{minHeight: 600, height: 'auto' }} >
                <Col xs={12} >
                    {
                        isLoading?
                        <SpinnerLoaderWithText />
                        :
                        <iframe title="Jasper Reports" src={url} style={styles.jasperContainer} ></iframe>
                    }
                </Col>

            </Row>
        );
    }
}

JasperReport.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        currentUser: state.user.currentUser,
        loginCompleted: state.jasperReport.loginCompleted,
        optionsCompleted: state.jasperReport.optionsCompleted,
        options: state.jasperReport.options
    }
}
export default connect(mapStateToProps, {LoadReport})(JasperReport);


// WEBPACK FOOTER //
// ./src/containers/crashDashboard/JasperReport.js